<template>
  <div class="snail-dkhd">
    <!-- 活动标题 -->
    <div v-wechat-title='"最强蜗牛 打卡返现活动"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-snail' v-show='preloadingShow'></div>
    </transition>

    <!-- 头部登录切换 -->
    <div>
      <Header
        v-if='!login_iden'
        :config='headerConfig'
        :isShowInfo='true' />
      <div v-else class="default-login-header">
        <div class="snail-icon"></div>
        <div class="info">
          <span class="main-title">{{user_userinfo.role_id}}</span>
          <span class="sub-title">{{user_userinfo.role_name}}[{{user_userinfo.server_name}}]</span>
        </div>
        <div class="btn">
          <a class="official-btn" href="https://snail.qingcigame.com/official/index_mobile.html"></a>
        </div>
      </div>
    </div>    

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="角色ID可在游戏中—蜗牛属性—蜗牛信息查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>

    <div class='snail-dk-home-page'>
      <div class="snail-dk-main">
        <div class="title">
          <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
            <div v-show="!preloadingShow">
              <img  src="../../../../assets/images/active/snail/dkhd/title_img.png"/>
              <p>{{ activityCountdownTimeInfo }}</p>
            </div>
          </transition>
        </div>
        <div class="role-reward-all">
          <div class="role-reward">
            <ul>
              <li class="li-1"><i><b></b></i></li>
              <li class="li-2"><i><b></b></i></li>
              <li class="li-3"><i><b></b></i></li>
              <li class="li-4"><i><b></b></i></li>
              <li class="li-5"><i><b></b></i></li>
              <li class="li-6"><i><b></b></i></li>
            </ul>
            <ol>
              <li class="li-1"></li>
              <li class="li-2"></li>
              <li class="li-3"></li>
              <li class="li-4"></li>
              <li class="li-5"></li>
              <li class="li-6"></li>
            </ol>
          </div>
          <div class="btn-all">
            <div>
              <a v-if="cur > 14 || cur === false || is_end === 2" :class="'tk-btn tk-btn-' + is_refund" href="javascript:;" @click="refundBtn()"></a>
              <a v-else :class="'tk-jd-btn tk-btn-' + is_refund" href="javascript:;" @click="refundBtn()">
                <p>打卡进度：{{ cur }}/15</p>
              </a>
            </div>
            <div>
              <a v-if="pay_end_time == 0" :class="'fk-btn fk-btn-' + is_echarge" href="javascript:;" @click="goPartake()"></a>
              <a v-else :class="'fk-btn-2 fk-btn-' + is_echarge" href="javascript:;" @click="goPartake2()">
                <p>{{ buyCountdownTimeInfo }}</p>
              </a>
            </div>
          </div>
        </div>
        <div class="rule-btn monitor-btn" data-event="活动详情" @click="clickRule()"></div>
        </div>
      
    </div>

    <!-- 规则-弹窗 -->
    <div :class="'rule-wrap popup_wrap rule-wrap-' + game_id" v-show="ruleShow" >
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="rule-box popup_wrap-box" v-show="ruleShow"></div>
      </transition>
      <div class="close-bg" @click="ruleShow = false"></div>
    </div>

    <!-- 挑战-弹窗 -->
    <div :class="'popup_wrap challenge-wrap challenge-wrap-' + game_id" @touchmove.prevent v-show="challengeShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="challengeShow">
          <div class="user-info">
            <p>服务器：<span>{{user_userinfo.server_name}}</span></p>
            <p>角色名：<span>{{user_userinfo.role_name}}</span></p>
          </div>
          <div class="btn-all">
            <a class="cancel-challenge-btn" href="javascript:;" @click="challengeShow=false"></a>
            <a class="confirm-challenge-btn" href="javascript:;" @click="participateChallenges()"></a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="challengeShow=false"></div>
    </div>

    <!-- 支付-弹窗 -->
    <div class="payment-wrap popup_wrap" v-show="paymentShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="paymentShow">
          <div :class="'payment-mode payment-mode-' + paymentData.payType">
            <div @click="selectPaymentType(item.payType)" v-for="(item, i) in paymentList" :key="i"><i :class="'icon-' +item.icon"></i><span>{{item.name}}</span><b :class="'select-' + item.select"></b></div>
          </div>
          <div class="btn-box">
            <a href="javascript:;" @click="goToPay()">立即参与</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="clonePayment()"></div>
    </div>

    <!-- 支付宝调用标签 -->
    <div id="aliPayBtn"></div>

    <!-- 退款失败-弹窗 -->
    <div class="refund-failed-wrap popup_wrap" v-show="refundFailedShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="refundFailedShow">
          <div class="btn-box">
            <a href="javascript:;" @click="refundFailedShow = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="clonePayment()"></div>
    </div>

    <!-- 退款成功-弹窗 -->
    <div class="refund-success-wrap popup_wrap" v-show="refundSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="refundSuccessShow">
          <div class="btn-box">
            <a href="javascript:;" @click="refundDef()">确定</a>
          </div>
        </div>
      </transition>
    </div>

    <!-- 付款成功-弹窗 -->
    <div class="payment-success-wrap popup_wrap" v-show="paymentSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="paymentSuccessShow">
          <div class="btn-box">
            <a href="javascript:;" @click="paymentSuccessShow = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="clonePayment()"></div>
    </div>

    <!-- 付款失败-弹窗 -->
    <div class="payment-failed-wrap popup_wrap" v-show="paymentFailedShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="paymentFailedShow">
          <div class="btn-box">
            <a href="javascript:;" @click="paymentFailedShow = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="clonePayment()"></div>
    </div>

    <!-- 支付提示-弹窗 -->
    <div class="popup_wrap payment-tips-page" v-show="paymentTipsShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="paymentTipsShow">
          <h2>提示</h2>
          <p>请确认是否完成支付</p>
          <div>
            <a @click="orderQuery(1)" href="javascript:;">已完成支付</a>
            <a @click="orderQuery(2)" href="javascript:;">未完成支付</a>
          </div>
        </div>
      </transition>
    </div>

    <!-- 提示弹窗 -->
    <div :class="'tips-wrap tips-wrap-' + tipsShow">
      <div :class="'show-' + tipsShow2"><p>{{ tips }}</p></div>
    </div>

    <!-- 阻止点击弹出-弹窗 -->
    <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
    
  </div>
</template>
<script>
import { Indicator } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { headerConfig } from '../../headerConfig';
import { wechatInfoAPI, onGetInitDataAPI, getUuidApi, paymentApi, wxPaymentApi, getRefundApi, getClockSignAPI } from '../api';
import { analysisParams, getTimeStamp, buriedLogger } from '@/utils/utils';

export default {
  name: 'dkhd',
  components: {
    Header,
    Footer,
    Login,
    Os
  },
  data () {
    return {
      headerConfig,
      gameName: 'snail',
      downloadUrl: 'https://static.qcplay.com/snail/official/',
      signInState: false,
      login_iden: false,
      preloadingShow: true,
      ruleShow: false,
      paymentShow: false,
      paymentTipsShow: false,
      challengeShow: false,
      refundFailedShow: false,
      refundSuccessShow: false,
      paymentFailedShow: false,
      paymentSuccessShow: false,
      preventShow: false,
      
      // 其他数据
      loginTypes: ['sms', 'password'],
      user_activity: '',
      user_userinfo: '',
      // 个人hash信息
      user_params: {
        role_id: '',
        token: '',
        game_id: '',
        server_id: '',
        os: '',
        web_bonus_id: '',
        zone: ''
      },
      // 支付选择类型
      my_payment_select: 0,
      // 当前支付类型
      paymentData: '',
      // open_id微信支付用
      open_id: '',
      // 2种支付方式
      paymentList: [
        {
          icon: 'zfb',
          name: '支付宝支付',
          select: '1',
          payType: 'alipay',
          payMethod: 'wap'
        },
        {
          icon: 'wx',
          name: '微信支付',
          select: '0',
          payType: 'wechat',
          payMethod: 'mp'
        }
      ],
      // 单独支付宝支付方式
      paymentList2: [
        {
          icon: 'zfb',
          name: '支付宝支付',
          select: '1',
          payType: 'alipay',
          payMethod: 'wap'
        }
      ],
      // 单独微信支付方式
      paymentList3: [
        {
          icon: 'wx',
          name: '微信支付',
          select: '1',
          payType: 'wechat',
          payMethod: 'mp'
        }
      ],
      // 提示语
      tips: '',
      // 提示显示1
      tipsShow: false,
      // 提示显示2
      tipsShow2: false,
      // 购买倒计时
      buyCountdownTimeInfo: '',
      // 活动剩余时间
      activityCountdownTimeInfo: '',
      // 玩家是否充值
      is_echarge: false,
      // 现金是否返还
      is_refund: false,
      // 活动是否结束
      is_end: false,
      // 支付订单
      order: '',
      // 购买的渠道
      way: '',
      // 打卡进度
      cur: false,
      // 充值倒计时
      pay_end_time: 0,
      // 是否查询前到接口
      is_update: 0,
      // 登录后的区服id
      game_id: '',
    };
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
  },
  mounted () {
    // 获取uuid-api
    this.$nextTick(() => {
      this.monitoringEquipment();
      this.getParams();
      this.isSetShare();
      // 埋点
      const bl = buriedLogger('snail', 'dkhd_page');
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum('蜗牛打卡h5_活动页统计');
      }, 200);
    })
  },
  methods: {
    monitoringEquipment () {
      if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
        this.paymentList = this.paymentList3
      }
    },
    // 获取hash参数
    getParams () {
      const params = analysisParams(window.location.href)
      this.user_params.role_id = params.role_id
      this.user_params.token = params.token
      this.user_params.game_id = params.game_id
      this.user_params.server_id = params.server_id
      this.user_params.os = params.os
      this.user_params.web_bonus_id = params.web_bonus_id
      this.user_params.zone = params.zone;
      if (params.role_id) {
        this.uuid();
      } else {
        this.getLoginContainer();
      }
      
    },
    uuid() {
      const host = window.location.host;
      const pathname = window.location.pathname;
      console.log(window.location.host)
      getUuidApi({ ...this.user_params })
        .then((response) => {
          if (Number(response.code) == 200) {
            this.user_params.uuid = response.data.uuid
            if (response.data.status == 1) {
              window.location.href = `//`+  host + pathname + `${getTimeStamp()}`;
              return
            }
          }
          // 请先登录
          if (Number(response.code) == 401) {
            // 开启弹窗
            this.wechatInfo() // codeId查询api
          }
          // id错误
          if (Number(response.code) == 405) {
            window.location.href = `//`+  host + pathname + `${getTimeStamp()}`;
          }
        })
    },
    // codeId查询api
    wechatInfo () {
      wechatInfoAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            this.open_id = response.data.open_id;
            if (response.data.open_id == null) {
              // 微信下去授权
              if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
                window.location.href = '//api.qingcigame.com/wechat/get/open/?back=' + encodeURIComponent(window.location.href)
                return
              }
            }
            return
          }
          this.tipsMessage(response.message, 2000)
        })
    },
    // 初始化
    getLoginContainer() {
      var _this = this
      onGetInitDataAPI().then(response => {
        if (Number(response.code) == 200) {  
          this.preloadingShow = false;        
          this.user_activity = response.data.activity;
          this.user_userinfo = response.data.user_info;
          
          this.onInitDataCallback(response);
          // 是否查询签到接口
          this.is_update = this.user_activity.is_update;
          if(this.is_update === 0) {
            this.clockSign();
          }
          // 是否初始化登录成功
          this.signInState = true;
          // 是否游戏中进来的
          this.login_iden = this.user_activity.login_iden;
          // 活动是否结束
          this.is_end = this.user_activity.is_end;
          // // 右上角的活动时间-是否结束
          if (this.user_activity.is_end == 0 && this.user_activity.end_time == 0) {
            this.activityCountdownTimeInfo = '活动已结束'
          } else if(this.user_activity.is_end == 2) {
            this.activityCountdownTimeInfo = '活动未开始'
          }
          // 玩家是否充值
          this.is_echarge = this.user_activity.is_echarge;
          // 现金是否返还
          this.is_refund = this.user_activity.is_refund;
          // 倒计时清除
          window.clearTimeout(this.interval);
          // 订单
          this.order = this.user_activity.trade_no;
          // 打卡进度
          this.cur = this.user_activity.cur;
          // 付款倒计时
          this.pay_end_time = this.user_activity.pay_end_time;
          // 区服id
          this.game_id = this.user_userinfo.game_id;
          // 购买倒计时时间-展示
          this.user_activity.pay_end_second !== 0 ? this.buyTimeShow() : this.buyCountdownTimeInfo = this.user_activity.pay_end_time + ' 截止购买'
          return
        }
        // 请登录
        if (Number(response.code) == 401) {
          this.preloadingShow = false;
          this.signInState = false
          this.onInitDataCallback(response)
          return
        }
        this.tipsMessage(response.message, 2000)
      })
    },
    // 查询签到
    clockSign() {
      getClockSignAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            // 打卡进度
            this.cur = response.data.cur;
          }
        }) 
    },
    // 选择支付方式
    selectPaymentType (payType) {
      if(this.paymentList.length > 1) {
        navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
        payType == 'wechat' ? this.my_payment_select = 1 : this.my_payment_select = 0
        for (var i = 0; i <= this.paymentList.length - 1; i++) this.paymentList[i].select = 0
        this.paymentList[this.my_payment_select].select = 1
        this.paymentData = this.paymentList[this.my_payment_select]
      }      
    },
    // 立即支付
    goToPay () {
      this.preventShow = true;
      paymentApi({ pay_type: this.paymentData.payType, pay_method: this.paymentData.payMethod, open_id: this.open_id })
      .then(response => {
        if (Number(response.code) == 200) {
          // 支付订单存储
          this.order = response.data.order
          this.paymentTipsShow = true
          // 移动端
          if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
            // 微信发送支付
            if (this.paymentData.payType == 'wechat') {
              // 外部浏览器调用
              if (this.paymentData.payMethod == 'mp') {
                wx.chooseWXPay({
                  timestamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                  nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                  package: response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: response.data.data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                  paySign: response.data.data.paySign, // 支付签名
                  success: function (res) {
                    // 支付成功后的回调函数
                    setTimeout(() => { this.preventShow = false }, 1000)
                  },
                  fail: function (res) {
                    setTimeout(() => { this.preventShow = false }, 1000)
                  }
                })
                setTimeout(() => { this.preventShow = false }, 2000)
              } else {
                if (response.data.data !== '') {
                  window.location.href = response.data.data
                  setTimeout(() => { this.preventShow = false }, 1000)
                }
              }
            } else if (response.data.data !== '') {
              document.getElementById('aliPayBtn').innerHTML = response.data.data
              document.forms['alipaysubmit'].submit()
              setTimeout(() => { this.preventShow = false }, 1000)
            }
          }
          this.logger.sum('蜗牛打卡h5_点击确定付款按钮');
          return
        }
        this.tipsMessage(response.message, 2000)
        setTimeout(() => { this.preventShow = false }, 500)
      })
    },
    // 选择角色后
    selectCallback () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
      });
    },
    // TAG: 相关业务方法
    onInvite () {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
    },
    // 购买倒计时时间显示
    buyTimeShow () {
      let _this = this
      let payEndTime = this.user_activity.pay_end_time
      let hours = payEndTime.split(':')[0] // 剩余小时数
      let minutes = payEndTime.split(':')[1] // 剩余分钟数
      let seconds = payEndTime.split(':')[2] // 剩余秒数
      function time () {
        if (seconds == 0) {
          seconds = 60
          minutes >= 1 ? minutes-- : hours--
          if (hours !== 0 && minutes !== 0 && seconds !== 0) {
            time()
          }
        } else {
          seconds--
          _this.buyCountdownTimeInfo = '活动倒计时：' + checkTime(hours) + ':' + checkTime(minutes) + ':' + checkTime(seconds)
          _this.interval = setTimeout(function () {
            time()
          }, 1000)
        }
      }time()

      function checkTime (i) {
        if (i < 10) { i = '0' + i }
        return i
      }
    },
    // 前往参与
    goPartake () {
      // 用户没登录
      if (!this.signInState) {
        this.getLoginContainer()
        return
      }
      // 活动已结束
      if (this.user_activity.is_end == 0) return this.tipsMessage('非常抱歉，活动已结束！', 2000);
      if (this.user_activity.is_end == 2) return this.tipsMessage('非常抱歉，活动未开始！', 2000);
      // 未充值-前往充值
      if (!this.is_echarge) {
        this.challengeShow = true;
        return
      } else {
        this.tipsMessage('您已参与活动，无需重复购买', 2000)
        return
      }
    },
    goPartake2 () {
      // 用户没登录
      if (!this.signInState) {
        this.getLoginContainer()
        return
      }
      // 未充值-前往充值
      if (!this.is_echarge) {
        this.challengeShow = true;
        return
      } else {
        this.tipsMessage('您已参与活动，无需重复购买', 2000)
        return
      }
    },
    // 参与挑战按钮
    participateChallenges () {
      this.challengeShow = false
      this.paymentShow = true
      this.paymentList[this.my_payment_select]
      this.paymentData = this.paymentList[this.my_payment_select]
      // 监测是否微信 (是为mp，否则map)
      if (this.paymentList.length > 1) {
        if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
          this.paymentList[1].payMethod = 'mp'
        } else {
          this.paymentList[1].payMethod = 'wap'
        }
      }
      this.logger.sum('蜗牛打卡h5_在打卡须知弹窗中点击立即参与按钮');
    },
    // 关闭支付弹窗
    clonePayment () {
      this.paymentShow = false
      this.getLoginContainer() // 初始化登录
    },
    orderQuery (type) {
      this.paymentTipsShow = false;
      // 订单轮询
      type == 1 ? this.wait = 15 : this.wait = 2;
      this.orderLoop(type);
    },
    // 订单轮询
    orderLoop (i) {
      if (this.wait > 0) {
        this.wxPayment(i)
        this.wait--
        this.preventShow = true;
        Indicator.open()
        setTimeout(() => {
          this.orderLoop(i);
        }, 1500)
      } else {
        this.preventShow = false;
      }
    },
    // 订单查询
    wxPayment (i) {
      wxPaymentApi({trade_no: this.order})
        .then((response) => {
          if (Number(response.code) == 200) {
            // 支付成功
            this.wait = 0
            if (i == 1) this.tipsMessage(response.message, 2000)
            this.paymentShow = false; // 关闭支付弹窗
            this.preventShow = false;
            this.paymentSuccessShow = true;
            this.getLoginContainer() // 初始化数据
            Indicator.close()
            return
          }
          if (Number(response.code) != 200) {
            if (this.wait == 0) {
              if (i == 1) this.tipsMessage(response.message, 2000)
              Indicator.close()
            }
          }
        })
    },
    // 开启规则弹窗
    clickRule () {
      if (!this.signInState) return this.getLoginContainer();
      this.ruleShow = true;
      this.logger.sum('蜗牛打卡h5_点击活动详情');
    },
    // 退款按钮
    refundBtn() {  
      // 用户没登录
      if (!this.signInState) return this.getLoginContainer();
      // 活动未开始
      if (this.user_activity.is_end == 2) return this.tipsMessage('非常抱歉，活动未开始！', 2000);
      // 是否充值过  
      if(!this.is_echarge) return this.tipsMessage('非常抱歉，您未参与活动！', 2000);
      // 已经退款完成
      if(this.is_refund == 3) return
      // 未30天-退款失败
      if(this.is_refund == 1) return this.refundFailedShow = true;
      // 开启退款api
      if(this.cur >= 14) {
        getRefundApi()
        .then((response) => {
          if (Number(response.code) == 200) {
            // 可成功退款
            this.refundSuccessShow = true;
            this.logger.sum('蜗牛打卡h5_点击返现成功统计');
            return
          }
          this.tipsMessage(response.message, 2000);
        }) 
      }           
    },
    // 退款返回确定
    refundDef () {
      this.refundSuccessShow = false
      this.getLoginContainer();
    },
    // TAG: 其他简易封装的方法
    tipsMessage (message, times) {
      this.tipsShow = true
      this.tips = message;
      setTimeout(() => { this.tipsShow2 = true }, 100)
      setTimeout(() => { this.tipsShow2 = false }, times - 200)
      setTimeout(() => { this.tipsShow = false; this.tips = ''; }, times)
    },
    osCancell () {
      // 关闭
      this.signInState = false;
      this.user_activity = '';
      this.user_userinfo = '';
      this.activityCountdownTimeInfo = '';
      this.buyCountdownTimeInfo = '';
      this.pay_end_time = 0;
      this.cur = false;
      this.is_echarge = false;
      this.is_refund = false;
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/dkhd/enter${getTimeStamp()}`,
        title: '最强蜗牛丨打卡返现活动开启！',
        imgUrl: 'https://download4.qcplay.com/qcgame-admin/xSYZA9DLv5obYeruDzVAtF4q1EKTvPW7IDN7J4Y7.jpg',
        desc: '周年庆限定，限时薅羊毛机会，花出去的钱还能要回来？'
      })
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'onCount',
      'setShare'
    ])
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.role_id) {
          // TAG: 注销的时候
        } else if (
          newValue.role_id !== oldValue.role_id || 
          newValue.account !== oldValue.account        
          ) {
            // 数据初始化
            this.getLoginContainer();
        }
      }
    }
  }
};
</script>

<style lang='less' scoped>
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/snail/dkhd/index/index.vue